import * as React from 'react'
import { BannerApp, StyledAppIcon } from '$views/components/AppMenu/AppMenu.style'
import { Block } from '$views/components'
import { Link } from '$views/components/Link'
import { routeProvider } from '$utils/routeProvider'

const crossIcon = require('$icons/cross.svg')

interface WindowWithNativeProps extends Window {
  ReactNativeWebView?: any
}

export const DeepLinkApp: React.FC = () => {
  const windowsWithNativeProps: WindowWithNativeProps = window

  const [showApp, setShowApp] = React.useState<boolean>(true)

  const closeBannerApp = () => setShowApp(false)

  return (
    <>
      {showApp && !windowsWithNativeProps.ReactNativeWebView && (
        <BannerApp>
          <Block flex justify="center">
            <Link href={routeProvider.deepLinkHome}>Ver en la aplicación</Link>
            <StyledAppIcon content={crossIcon} onClick={closeBannerApp} size="s" />
          </Block>
        </BannerApp>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/AppMenu/components/DeepLinkApp.tsx